import { CenterItem, RowAlignedItems } from '@components/LinearLayout';
import { H1, H4, PBold, PSmall } from '@components/Typography';

import { animated } from '@react-spring/web';
import { FOOTER_WIDTH } from '@utils/constants';
import { styled } from 'styled-components';
import { Column } from '../FooterSocial/styles';

export const PartnersSectionRoot = styled.div<{ $lightMode?: boolean }>`
  width: 100%;
  margin: auto;
  background-color: ${({ theme }) => theme.color.transparent};
  padding: 4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 0 2rem 4rem 2rem;
  }
`;

export const PartnersTitle = styled(H1)`
  text-align: center;
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size45};
    line-height: 5.4rem;
  }
`;

export const PartnersSubtitle = styled(H4)`
  text-align: center;
  color: ${({ theme }) => theme.color.mobilityGrey};
  width: min(${FOOTER_WIDTH}, 100%);
  margin: auto;
  padding: 0 2rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    line-height: ${({ theme }) => theme.lineHeight.height115};
  }
`;

export const PartnersListContainer = styled(Column)`
  width: min(${FOOTER_WIDTH}, 100%);
  margin: auto;
`;

export const PartnerItemsContainer = styled(animated.div)`
  width: min(${FOOTER_WIDTH}, 100%);
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 3rem 0;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    gap: 1.5rem;
  }
`;

export const PartnerModalRoot = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`;

export const LogoWrapper = styled(CenterItem)`
  height: 13rem;
`;

export const BodyWrapper = styled.div`
  background: ${({ theme }) => theme.color.grey2};
  padding: 3rem 4rem;
  display: grid;
  grid-gap: 2rem;
  grid-template-rows: 1fr auto;
`;

export const DescriptionText = styled(PSmall)`
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const PartnersDescriptionText = styled(PSmall)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  text-align: center;
  margin-top: 2rem;
  font-size: ${({ theme }) => theme.fontSize.size22};
`;

export const FooterTitle = styled(PBold)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
`;

export const TagsWrapper = styled(RowAlignedItems)`
  flex-wrap: wrap;
  gap: 1rem;
`;

export const Tag = styled.div<{ color: string }>`
  padding: 0.2rem 1rem;
  background-color: ${({ color }) => color};
  color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.radius5};
`;

export const PartnersTitleWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  gap: 1.7rem;
  padding-bottom: 1rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    gap: 1rem;
  }
`;
